var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-contact"},[_c('div',{staticClass:"contact-container"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/","target":"_blank"}},[_vm._v(" 浙ICP备12047051号-4 ")]),_c('p',[_vm._v("五金产品工业设计专利库 Copyright 2022, All Rights Reserved")])])])
}]

export { render, staticRenderFns }